import React, { useRef } from 'react'
import cn from 'classnames'

import { Button } from '@components/Buttons'
import { PaperclipIcon } from '@components/icons/PaperclipIcon'
import { UploadFileProps } from './interface'

export const UploadFile = React.memo(function ({
  name,
  className,
  label,
  textButton,
  image,
  acceptTypes,
  touched,
  error,
  onChange,
}: UploadFileProps) {
  const inputRef = useRef<HTMLInputElement>(null)

  function showUploadDialog() {
    const event = inputRef.current
    if (event) {
      event.click()
    }
  }

  return (
    <div
      className={cn('relative rounded-[8px] overflow-hidden', className)}
      id={`${name}.url`}
    >
      {label && (
        <div className='text-[12px] text-secondary-1 mb-[4px] font-light'>
          {label}
        </div>
      )}
      <Button
        className={cn(
          'font-mitr w-full text-[14px] font-medium text-secondary-1 dark:text-dark-10 border-[1px]',
          {
            'border-secondary-1 dark:border-dark-10': !(touched && error),
            'border-red': touched && error,
          }
        )}
        type='button'
        onClick={showUploadDialog}
      >
        {textButton}
      </Button>
      {image?.name && (
        <div className='flex items-center space-x-[5px] mt-[10px]'>
          <PaperclipIcon className='text-primary' width='16' height='16' />
          <a
            href={image.url}
            className='text-[12px] font-light text-primary underline cursor-pointer'
            target='_blank'
            rel='noreferrer'
          >
            {image.name}
          </a>
        </div>
      )}

      <input
        ref={inputRef}
        className='hidden'
        type='file'
        accept={acceptTypes}
        onChange={onChange}
      />
    </div>
  )
})
